import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=43518548&scoped=true&"
import script from "./user-info.vue?vue&type=script&lang=js&"
export * from "./user-info.vue?vue&type=script&lang=js&"
import style0 from "./user-info.vue?vue&type=style&index=0&id=43518548&lang=scss&scoped=true&"
import style1 from "./user-info.vue?vue&type=style&index=1&id=43518548&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43518548",
  null
  
)

export default component.exports